import React from "react";
import styles from "./CustomCheckbox.module.css"
import { MdCheck } from "react-icons/md";


const CustomCheckbox = ({
    label,
    color,
    title,
    className,
    ...props
  }) => {
  
  const colorStyles = color ? {color, borderColor: color} : null

  const wrapClassNames = `${styles.wrapper} ${className || ''}`

  return (
    <div title={title} className={wrapClassNames}>
      <label className={styles.checkbox}>
        <input type="checkbox" {...props} />
        <i style={colorStyles} className={styles.fakeBox}>
          {props.checked && <MdCheck size={20} color={color}/>}
        </i>
        <span className={styles.span}>{label}</span>
      </label>
    </div>
  );
};

export default CustomCheckbox;
